"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LocaleReceiver = _interopRequireDefault(require("./LocaleReceiver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _LocaleReceiver.default;
exports.default = _default;